/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Luxury_Serif_PlayfairInputs */

const en_luxury_serif_playfair = /** @type {(inputs: Luxury_Serif_PlayfairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luxury Serif (Playfair)`)
};

const es_luxury_serif_playfair = /** @type {(inputs: Luxury_Serif_PlayfairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serif de Lujo (Playfair)`)
};

const fr_luxury_serif_playfair = /** @type {(inputs: Luxury_Serif_PlayfairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serif de luxe (Playfair)`)
};

const de_luxury_serif_playfair = /** @type {(inputs: Luxury_Serif_PlayfairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luxury Serif (Playfair)`)
};

const ja_luxury_serif_playfair = /** @type {(inputs: Luxury_Serif_PlayfairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラグジュアリーセリフ (Playfair)`)
};

const zh_luxury_serif_playfair = /** @type {(inputs: Luxury_Serif_PlayfairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`奢华衬线 (Playfair)`)
};

const ar_luxury_serif_playfair = /** @type {(inputs: Luxury_Serif_PlayfairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فاخر بحواف (Playfair)`)
};

const id_luxury_serif_playfair = /** @type {(inputs: Luxury_Serif_PlayfairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serif Mewah (Playfair)`)
};

const it_luxury_serif_playfair = /** @type {(inputs: Luxury_Serif_PlayfairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luxury Serif (Playfair)`)
};

const ru_luxury_serif_playfair = /** @type {(inputs: Luxury_Serif_PlayfairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Роскошный (Playfair)`)
};

const pt_luxury_serif_playfair = /** @type {(inputs: Luxury_Serif_PlayfairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luxury Serif (Playfair)`)
};

const ko_luxury_serif_playfair = /** @type {(inputs: Luxury_Serif_PlayfairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`럭셔리 세리프 (Playfair)`)
};

/**
* | output |
* | --- |
* | "Luxury Serif (Playfair)" |
*
* @param {Luxury_Serif_PlayfairInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const luxury_serif_playfair = /** @type {((inputs?: Luxury_Serif_PlayfairInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Luxury_Serif_PlayfairInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_luxury_serif_playfair(inputs)
	if (locale === "es") return es_luxury_serif_playfair(inputs)
	if (locale === "fr") return fr_luxury_serif_playfair(inputs)
	if (locale === "de") return de_luxury_serif_playfair(inputs)
	if (locale === "ja") return ja_luxury_serif_playfair(inputs)
	if (locale === "zh") return zh_luxury_serif_playfair(inputs)
	if (locale === "ar") return ar_luxury_serif_playfair(inputs)
	if (locale === "id") return id_luxury_serif_playfair(inputs)
	if (locale === "it") return it_luxury_serif_playfair(inputs)
	if (locale === "ru") return ru_luxury_serif_playfair(inputs)
	if (locale === "pt") return pt_luxury_serif_playfair(inputs)
	return ko_luxury_serif_playfair(inputs)
});